import { useEffect, useState } from "react";
import { SelectUi } from "../../ui";
import { get_estadospedidoventa } from "../../../actions";

export const EstadoPedidoVentaSelect = ({ ...restProps }) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const OnLoadFormasPago = async () => {
      const datos = await get_estadospedidoventa();
      setOptions(datos);
    };
    OnLoadFormasPago();
  }, []);

  return <SelectUi data={options} {...restProps} />;
};
